import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UserUpdatePage = lazy(() => import('../views/update/UserUpdatePage'));

export function UserUpdatePageLazy() {
	return (
		<PageSuspense>
			<UserUpdatePage />
		</PageSuspense>
	);
}
